const error403 = {
  name: 'Erro 403',
  title: '¡Ups! Acceso denegado',
  subtitle: 'Solo las personas autorizadas pueden acceder a esta página.',
};

export default error403;
